//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapGetters, mapActions, mapMutations } from "vuex";
import { uid } from "quasar";
import setApiErrors from "@/components/Diagrams/config/subcomponents/set-api-errors.vue";
import setApiRules from "@/components/Diagrams/config/subcomponents/set-api-rules.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQSelectionCard from "@/components/Generics/AQSelectionCard/AQSelectionCard.vue";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import { setPluginIcon } from "@/assets/js/appFunc";
import CustomHeadersApiItem from "@/components/Diagrams/config/subcomponents/CustomHeadersApiItem.vue";
import AQTreeConfig from "../../Generics/TreeConfiguration/AQTreeConfig.vue";

export default {
    components: {
        setApiErrors,
        setApiRules,
        AQTreeConfig,
        AQButton,
        AQSelectionCard,
        AQModal,
        AQDropdown,
        AQDialog,
        AQTooltip,
        CustomHeadersApiItem,
        AQCard
    },
    props: {
        uuid: {
            required: true,
            type: String
        },
        readonly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selectedErrorMethod: false,
            triggerApiCall: false,
            errors: [],
            requestToLoad: [],
            responseToLoad: [],
            requestObject: {},
            responseObject: {},
            minCharacters: 0,
            maxCharacters: 1000,
            modalOpened: false,
            hasSave: { color: "positive" },
            saveEnable: false,
            selectApi1: "",
            selectApi: "",
            selectMethod: "",
            selectMethods1: "",
            tabsConfiguration: "request",
            panelsConfiguration: "",
            showRequest: false,
            showResponse: false,
            newArray: [],
            methodsFinal: [],
            defaultPathOptions: [],
            selectDefaultPath: [],
            requestValue: false,
            responseValue: false,
            dirty: false,
            defaultPath: "",
            changeRequestResponse: false,
            errorDefaultPath: false,
            resetDefaultPathOption: false,
            arrayOption: [],
            arrayRulesList: [],
            openModalRule: false,
            arrayOfType: [
                "string",
                "date",
                "time",
                "datetime",
                "integer",
                "decimal",
                "attachment"
            ],
            apiRulesKey: 0,
            selectApiMod: [],
            selectApiMethod: [],
            apiOptions: [],
            apiMethodsOptions: [],
            methodName: "",
            disableMethod: true,
            resetMethodsMod: false,
            resetApiMod: false,
            showDialog: false,
            showCustomHeader: false,
            customHeaderListRequest: [],
            customHeaderListResponse: [],
            initialCustomHeaderListRequest: [],
            initialCustomHeaderListResponse: [],
            toastApiNotFound: null,
            requestMappingData: null,
            unsavedRequestMappingData: {},
            responseMappingData: null,
            unsavedResponseMappingData: {},
            dmMappedValueObject: null,
            currentMappings: null,
            currentFullPaths: [],
            reservedMappingsKeys: ["__migrated", "__customHeaders"],
            requestObjectSections: [],
            requestObjectSectionsNrNow: 0,
            responseObjectSections: [],
            responseObjectSectionsNrNow: 0
        };
    },
    computed: {
        ...mapGetters("diagrams", [
            "selectedPluginConfigData",
            "selectedPluginUuid",
            "diagramData",
            "setAllAppi",
            "setAllResponseCallApi",
            "setAllErrorsCallApi",
            "setAllRequestCallApi",
            "modelForProcessDefinition",
            "setModelForProcessDefinition"
        ]),
        modalDone() {
            return {
                label: this.$t("generic.done"),
                disabled: !this.saveEnable
            };
        },
        getSelectDefaultPathProps() {
            return {
                label: this.$t("diagrams.components.configApi.defaultPath"),
                options: this.newArray,
                resetSelectedData: this.resetDefaultPathOption,
                errorLabel: this.$t("diagrams.components.configApi.warningDefultPath"),
                error: this.errorDefaultPath,
                disable: !this.newArray.length
            };
        },
        getSelectApiProps() {
            return {
                label: this.$t("diagrams.components.configApi.apiLabel"),
                options: this.apiOptions,
                resetSelectedData: this.resetApiMod
            };
        },
        getApiMethodsProps() {
            return {
                label: this.$t("diagrams.components.configApi.metLabel"),
                options: this.apiMethodsOptions,
                disable: this.disableMethod,
                resetSelectedData: this.resetMethodsMod,
                error: this.selectedErrorMethod,
                errorLabel: this.$t("diagrams.components.configApi.selectedMethodErrorLabel")
            };
        },
        setTitle() {
            const currentApi = this.findApiConfigured();
            return currentApi ? `${currentApi.platformName || currentApi.name} - ${this.selectedPluginConfigData.apiConfigure.method}` : false;
        }
    },
    watch: {
        setAllAppi: {
            handler() {
                this.loadDataForApi();
            }
        },
        selectedPluginConfigData: {
            handler(newValue, oldValue) {
                if (oldValue && newValue.apiConfigure) {
                    const currentApi = this.findApi(newValue.apiConfigure.apiId
                        ? newValue.apiConfigure.apiId : newValue.apiConfigure.api, newValue.apiConfigure.apiId || null);
                    if (currentApi) {
                        this.methodName = newValue.apiConfigure.method;
                    } else {
                        this.showToastApiNotFound();
                    }
                }
            },
            immediate: true
        }
    },
    created() {
        this.getAllAppi();
        setTimeout(() => {
            this.triggerApiCall = true;
        }, 500);
        this.$root.$on("sendRequestResponse", data => {
            this.dirty = true;
            this.saveEnable = true;
            this.changeRequestResponse = true;
            if (data && data.routeName === this.$route.name) {
                if (this.tabsConfiguration === "request") {
                    this.unsavedRequestMappingData[`${data.newDataItem.fullPath}`] = data.newDataItem.value;
                } else if (this.tabsConfiguration === "response") {
                    this.unsavedResponseMappingData[`${data.newDataItem.fullPath}`] = data.newDataItem.value;
                }
            }
        });
        this.$root.$on("updateMappingsMigration", data => {
            if (data && data.routeName === this.$route.name) {
                this.currentFullPaths = this.currentFullPaths.concat(data.sectionFullPaths);
                if (data.isRequest) {
                    this.currentMappings = { ...this.currentMappings, ...this.requestMappingData };
                    this.requestObjectSectionsNrNow += 1;
                } else {
                    this.currentMappings = { ...this.currentMappings, ...this.responseMappingData };
                    this.responseObjectSectionsNrNow += 1;
                }

                if (Object.keys(data.addItem).length) {
                    // $body alias mappings migration addition
                    this.currentMappings = { ...this.currentMappings, ...data.addItem };
                }
                if (this.currentMappings && Object.keys(this.currentMappings).length && data.removeArray && data.removeArray.length) {
                    // $body alias mappings migration removals
                    data.removeArray.forEach(el => {
                        delete this.currentMappings[el];
                    });
                }

                const allSectionsReceived = data.isRequest ? this.requestObjectSectionsNrNow === this.requestObjectSections.length
                    : this.responseObjectSectionsNrNow === this.responseObjectSections.length;

                if (allSectionsReceived && this.currentMappings
                    && this.currentMappings.__migrated && Object.keys(this.currentMappings).length
                    && this.currentFullPaths && this.currentFullPaths.length) { // doubled/untargeted mappings migration conversion
                    let currentSections = [];
                    if (data.isRequest) {
                        this.requestObjectSectionsNrNow = 0;
                        currentSections = this.requestObjectSections;
                    } else {
                        this.responseObjectSectionsNrNow = 0;
                        currentSections = this.responseObjectSections;
                    }
                    Object.keys(this.currentMappings).forEach((key) => {
                        if (!this.reservedMappingsKeys.includes(key) && !this.currentFullPaths.includes(key)) {
                            currentSections.forEach((item) => {
                                if (this.currentFullPaths.includes(`${item}.${key}`)) {
                                    this.currentMappings[`${item}.${key}`] = this.currentMappings[`${key}`];
                                    delete this.currentMappings[`${key}`];
                                }
                            });
                        }
                    });
                    delete this.currentMappings.__migrated;
                    this.currentFullPaths = [];
                }

                if (data.isRequest) {
                    this.requestMappingData = { ...this.currentMappings };
                } else {
                    this.responseMappingData = { ...this.currentMappings };
                }
                this.currentMappings = null;
            }
        });
    },
    activated() {
        if (this.triggerApiCall) {
            this.getAllAppi();
        }
    },
    methods: {
        ...mapActions("diagrams", [
            "getAllAppi",
            "getResponseCallApi",
            "getErrorsCallApi",
            "getRequestCallApi",
            "getModelForProcessDefinition"
        ]),
        ...mapMutations("diagrams", ["setIsFromResponse"]),
        setPluginIcon,
        valueSelected(evt) {
            this.defaultPath = evt[0].value;
            this.saveEnable = true;
            this.dirty = true;
        },
        dialogConfirmAction(actionMessage) {
            if (actionMessage === "ok") {
                this.dirty = false;
                this.selectedErrorMethod = false;
                this.errorDefaultPath = false;
                this.errors = [];
                this.discardUnsavedMappings();
                this.customHeaderListRequest = [...this.initialCustomHeaderListRequest];
                this.customHeaderListResponse = [...this.initialCustomHeaderListResponse];
                if (this.dmMappedValueObject) {
                    this.$store.commit("diagrams/setConfigData", {
                        uuid: this.uuid,
                        value: this.dmMappedValueObject,
                        property: "apiConfigure"
                    });
                }
                this.resetInitialApiValues();
                this.hide();
            } else {
                this.showDialog = false;
            }
        },
        resetInitialApiValues() {
            const currentApi = this.findApiConfigured();
            if (currentApi) {
                this.selectApiMod = [{ label: currentApi.platformName || currentApi.name,
                    value: this.selectedPluginConfigData.apiConfigure.api,
                    id: this.selectedPluginConfigData.apiConfigure.id }];
                this.selectApiMethod = [{ label: this.selectedPluginConfigData.apiConfigure.method,
                    value: this.selectedPluginConfigData.apiConfigure.method }];
                this.defaultPath = this.selectedPluginConfigData.apiConfigure.defaultPath;
                this.selectDefaultPath = this.defaultPath ? this.newArray.filter(elem => elem.value === this.defaultPath) : [];
                this.apiMethodsOptions = this.parseMethod(currentApi.webServiceMethods);
            } else {
                this.selectApiMod = [];
                this.selectApiMethod = [];
                this.defaultPath = "";
            }
        },
        deleteCustomHeaderItem(item) {
            this.saveEnable = true;
            this.dirty = true;
            if (this.tabsConfiguration === "request") {
                this.customHeaderListRequest.splice(item, 1);
            } else {
                this.customHeaderListResponse.splice(item, 1);
            }
        },
        insertParamName(obj) {
            this.saveEnable = true;
            this.dirty = true;
            if (this.tabsConfiguration === "request") {
                if (obj.fromParamName) {
                    this.customHeaderListRequest[obj.index].parameterLabel = obj.paramName;
                } else {
                    this.customHeaderListRequest[obj.index].paramValue = obj.paramName;
                }
            } else {
                this.customHeaderListResponse[obj.index].parameterLabel = obj.paramName;
            }
        },
        setResponse(val) {
            this.$store.commit("diagrams/setIsFromResponse", val);
        },
        setActionRule(value) {
            this.arrayRulesList = value;
            this.apiRulesKey += 1;
            this.saveEnable = true;
            this.dirty = true;
        },
        addCustomHeader(fromRequest) {
            this.saveEnable = true;
            this.dirty = true;
            if (fromRequest) {
                this.customHeaderListRequest.push({
                    parameterLabel: "",
                    paramValue: ""
                });
            } else {
                this.customHeaderListResponse.push({
                    parameterLabel: "",
                    paramValue: ""
                });
            }
        },
        changeApi(evt) {
            this.selectApiMod = evt;
            this.saveEnable = this.selectApiMod.length;
            if (this.selectApiMod.length) {
                this.disableMethod = false;
                this.resetMethodsMod = !!this.selectApiMethod.length;
                setTimeout(() => {
                    this.resetMethodsMod = false;
                }, 0);
                this.saveEnable = true;
                this.showRequest = false;
                this.showResponse = false;
                this.arrayRulesList = [];
                this.errors = [];
                this.customHeaderListRequest = [];
                this.customHeaderListResponse = [];
                this.showCustomHeader = false;
                const currentApi = this.findApi(this.selectApiMod[0].id, true);
                if (currentApi) {
                    this.apiMethodsOptions = this.parseMethod(currentApi.webServiceMethods);
                    if ((!currentApi.system || (currentApi.system && currentApi.system === "false")) && currentApi.type === "SWAGGER") {
                        this.showCustomHeader = true;
                    }
                }
                this.dirty = true;
            }
        },

        changeMethod(evt) {
            if (evt.length) {
                this.changeResponse(this.selectApiMod[0].id, evt[0].value, []);
                this.changeRequest(this.selectApiMod[0].id, evt[0].value, []);
                this.responseValue = true;
                this.saveEnable = true;
                this.requestValue = true;
                this.changeRequestResponse = true;
                this.arrayRulesList = [];
                this.customHeaderListRequest = [];
                this.customHeaderListResponse = [];
                this.methodName = evt[0].value;
                this.showRequest = true;
                this.discardUnsavedMappings();
                this.discardSavedMappings();
                const currentApi = this.findApi(this.selectApiMod[0].id, true);
                if (currentApi) {
                    this.apiMethodsOptions = this.parseMethod(currentApi.webServiceMethods);
                }
                this.showResponse = true;
                this.dirty = true;
            }
        },

        parseMethod(obj) {
            const data = obj.map(param => ({
                label: param,
                value: param
            }));
            return data;
        },

        createActions() {
            if (this.diagramData.connectors.length > 0) {
                this.newArray = [];
                const object = this.diagramData.connectors;
                for (let k = 0; k < object.length; k++) {
                    if (object[k].from === this.selectedPluginUuid) {
                        for (let j = 0; j < this.diagramData.content.length; j++) {
                            if (object[k].to === this.diagramData.content[j].uuid) {
                                this.newArray.push({
                                    label: this.diagramData.content[j].label.value,
                                    value: object[k].uuid,
                                    iconName: this.diagramData.content[j].id,
                                    svgIcon: { name: this.setPluginIcon({ pluginType: this.diagramData.content[j].id }), size: "16px" }
                                });
                            }
                        }
                    }
                }
            }
        },

        configResponse(value) {
            const data = [];
            let child = [];
            // eslint-disable-next-line guard-for-in,no-restricted-syntax
            for (const i in value) {
                const dataParam = value[i];
                if (typeof dataParam === "object") {
                    // eslint-disable-next-line no-restricted-syntax
                    for (const j in dataParam) {
                        if (j !== "path") {
                            child.push({
                                name: j,
                                value: dataParam[j]
                            });
                        }
                    }
                    data.push({ name: i, childs: child });
                    child = [];
                } else {
                    data.push({ name: i, value: value[i] });
                }
            }
            return data;
        },
        // eslint-disable-next-line consistent-return
        findValue(dataLoad, index, param, parentField) {
            let object = {};
            if (param === "label") {
                // eslint-disable-next-line no-restricted-syntax
                for (const parameter in dataLoad) {
                    if (typeof dataLoad[parameter] === "object") {
                        // eslint-disable-next-line guard-for-in,no-restricted-syntax
                        for (const key in dataLoad[parameter]) {
                            const child1 = `${parameter}.${key}`;
                            const child2 = parentField ? `${parentField}.${index}` : index;
                            if (child1 === child2) {
                                return dataLoad[parameter][key];
                            }
                        }
                    } else if (parameter === index) {
                        return dataLoad[parameter];
                    }
                }
            } else {
                object = dataLoad.find(parameter => parameter.index === index);
                return object ? object.value : "";
            }
        },
        responseObjectTosend(value, errors) {
            const data2 = [];
            if (value.length > 0) {
                for (let i = 0; i < value.length; i++) {
                    const data1 = {
                        conditions: value[i].conditions,
                        index: i,
                        uuid: value[i].uuid,
                        path: value[i].path
                    };
                    data2.push({
                        parent: data2.length + 1,
                        rule: data1
                    });
                }
            }
            if (errors && errors.length) {
                errors.forEach(el => {
                    data2.push({
                        parent: data2.length + 1,
                        code: el.value ? el.value[0] : el[0],
                        action: el.action
                    });
                });
            }
            return data2;
        },
        valueChildrenResponse(value, param, par) {
            const parent = par || value.label;
            const childrenObj = value.children;
            let objectToReturn;
            let child;
            for (let i = 0; i < childrenObj.length; i++) {
                if (childrenObj.children && childrenObj.children.length) {
                    child = `${parent}.${childrenObj[i].label}`;
                    this.valueChildrenResponse(childrenObj, param, parent);
                } else {
                    child = `${parent}.${childrenObj[i].label}`;
                    if (child === param) {
                        objectToReturn = {
                            value: childrenObj[i].value,
                            type: childrenObj[i].type
                        };
                        break;
                    }
                }
            }
            return objectToReturn;
        },

        findMapping(value) {
            let objectToReturn = {};
            for (let i = 0; i < this.responseObject.length; i++) {
                if (this.responseObject[i].children && this.responseObject[i].children.length) {
                    objectToReturn = this.valueChildrenResponse(this.responseObject[i], value);
                } else if (this.responseObject[i].label === value) {
                    objectToReturn = {
                        value: this.responseObject[i].value,
                        type: this.responseObject[i].type
                    };
                    break;
                }
            }
            return objectToReturn;
        },

        pluginInformation(value) {
            let object = {};
            if (!this.newArray.length) {
                this.createActions();
            }
            const objectPlugin = this.newArray.find(elem => elem.value === value);
            if (objectPlugin) {
                object = {
                    idPlugin: objectPlugin.iconName,
                    labelPlugin: objectPlugin.label
                };
            }
            return object;
        },

        loadCardsData(value) {
            let rspObj = [];
            let select = "";
            let value1 = "";
            let typeRes = null;
            const arrayErrors = [];
            let object = [];
            let condition = {};
            object = this.errors;
            if (value.length > 0) {
                rspObj = [];
                for (let i = 0; i < value.length; i++) {
                    if (value[i].response && value[i].response.code === 200) {
                        condition = {};
                        const obj = value[i].response;
                        // eslint-disable-next-line no-restricted-syntax
                        for (const j in obj) {
                            if (typeof obj[j] === "object") {
                                let valueResp = null;
                                let pluginData = null;
                                // eslint-disable-next-line no-restricted-syntax
                                for (const k in obj[j]) {
                                    if (k !== "path") {
                                        select = this.findMapping(`${j}.${k}`);
                                        valueResp = select && select.value ? `\${(${select.value})!}` : "";
                                        typeRes = select.type;
                                        value1 = obj[j][k];
                                    }
                                }
                                pluginData = this.pluginInformation(value[i].action);
                                condition = {
                                    logicalCondition: "==",
                                    order: -1,
                                    type: "condition",
                                    val1: { type: "MOD", fieldType: typeRes, value: valueResp },
                                    val2: { type: "TXT", fieldType: typeRes, value: value1 }
                                };
                                rspObj.push({
                                    conditions: condition,
                                    index: rspObj && rspObj.length ? rspObj.length : 0,
                                    uuid: uid(),
                                    path: value[i].action,
                                    idPlugin: pluginData.idPlugin,
                                    labelPlugin: pluginData.labelPlugin
                                });
                            } else {
                                let pluginData = null;
                                let valueResp = null;
                                select = this.findMapping(j);

                                pluginData = this.pluginInformation(value[i].action);
                                valueResp = select.value ? `\${(${select.value})!}` : "";
                                typeRes = select.type;
                                condition = {
                                    logicalCondition: "==",
                                    order: -1,
                                    type: "condition",
                                    val1: { type: "MOD", fieldType: typeRes, value: valueResp },
                                    val2: { type: "TXT", fieldType: typeRes, value: obj[j] }
                                };
                                rspObj.push({
                                    conditions: condition,
                                    index: rspObj && rspObj.length ? rspObj.length : 0,
                                    uuid: uid(),
                                    path: value[i].action,
                                    idPlugin: pluginData.idPlugin,
                                    labelPlugin: pluginData.labelPlugin
                                });
                            }
                        }
                    } else if (value[i].code && value[i].code !== 200) {
                        let objectErrors = {};
                        for (let j = 0; j < object.length; j++) {
                            const param = object[j];
                            if (param[0] === value[i].code) {
                                const pluginData = this.pluginInformation(value[i].action);
                                objectErrors = {
                                    action: value[i].action,
                                    value: param,
                                    idPlugin: pluginData.idPlugin,
                                    labelPlugin: pluginData.labelPlugin
                                };
                                arrayErrors.push(objectErrors);
                            }
                        }
                        if (arrayErrors) {
                            this.errors = [];
                            this.errors = arrayErrors;
                        }
                    } else if (value[i].rule) {
                        let pluginData = null;
                        pluginData = this.pluginInformation(value[i].rule.path);
                        value[i].rule.idPlugin = pluginData.idPlugin;
                        value[i].rule.labelPlugin = pluginData.labelPlugin;
                        rspObj.push(value[i].rule);
                    }
                }
                this.arrayRulesList = rspObj;
            }
        },
        updateErr(value) {
            this.errors = value;
            this.saveEnable = true;
            this.dirty = true;
        },

        findApi(api, findById) {
            let found;
            if (api) {
                found = this.setAllAppi.filter(item => {
                    let foundItem;
                    if ((findById && api === item.id) || (!findById && api === item.platformName) || (!findById && api === item.name)) {
                        foundItem = item;
                    }
                    return foundItem;
                });
            }
            found = found ? found[0] : null;
            return found;
        },
        findApiConfigured() {
            return this.selectedPluginConfigData && this.selectedPluginConfigData.apiConfigure
                ? this.findApi(this.selectedPluginConfigData.apiConfigure.apiId
                    ? this.selectedPluginConfigData.apiConfigure.apiId
                    : this.selectedPluginConfigData.apiConfigure.api, this.selectedPluginConfigData.apiConfigure.apiId || null)
                : false;
        },

        loadDataForApi() {
            let currentApi;
            if (this.setAllAppi.length && this.selectedPluginConfigData && this.selectedPluginConfigData.apiConfigure) {
                if (this.selectedPluginConfigData.apiConfigure.requests.__customHeaders && !this.customHeaderListRequest.length) {
                    Object.keys(this.selectedPluginConfigData.apiConfigure.requests.__customHeaders).forEach(key => {
                        this.customHeaderListRequest.push({
                            paramValue: this.selectedPluginConfigData.apiConfigure.requests.__customHeaders[key],
                            parameterLabel: key
                        });
                    });
                    this.initialCustomHeaderListRequest = JSON.parse(JSON.stringify(this.customHeaderListRequest));
                }
                if (this.selectedPluginConfigData.apiConfigure.responses && !this.customHeaderListResponse.length) {
                    this.selectedPluginConfigData.apiConfigure.responses.forEach((responseEl) => {
                        if (responseEl.response && responseEl.response.__customHeaders) {
                            Object.keys(responseEl.response.__customHeaders).forEach(key => {
                                this.customHeaderListResponse.push({
                                    paramValue: responseEl.response.__customHeaders[key],
                                    parameterLabel: key
                                });
                            });
                            this.initialCustomHeaderListResponse = JSON.parse(JSON.stringify(this.customHeaderListResponse));
                        }
                    });
                }
                currentApi = this.findApiConfigured();
                if (currentApi) {
                    this.apiMethodsOptions = this.parseMethod(currentApi.webServiceMethods);
                    if ((!currentApi.system || (currentApi.system && currentApi.system === "false")) && currentApi.type === "SWAGGER") {
                        this.showCustomHeader = true;
                    }
                    if (this.selectedPluginConfigData.apiConfigure.requests) {
                        this.changeRequest(
                            currentApi.id,
                            this.selectedPluginConfigData.apiConfigure.method,
                            this.selectedPluginConfigData.apiConfigure.requests
                        );
                    }
                    if (this.selectedPluginConfigData.apiConfigure.responses && this.selectedPluginConfigData.apiConfigure.responses.length) {
                        this.selectedPluginConfigData.apiConfigure.responses.forEach(el => {
                            if (el.code === 200) {
                                this.changeResponse(
                                    currentApi.id,
                                    this.selectedPluginConfigData.apiConfigure.method,
                                    this.selectedPluginConfigData.apiConfigure.responses
                                );
                            }
                        });
                    } else {
                        this.changeResponse(currentApi.id, this.selectedPluginConfigData.apiConfigure.method, []);
                    }
                    if (this.selectedPluginConfigData.apiConfigure.defaultPath) {
                        this.defaultPath = this.selectedPluginConfigData.apiConfigure.defaultPath;
                        this.resetDefaultPathOption = true;
                        setTimeout(() => {
                            this.resetDefaultPathOption = false;
                        }, 0);
                        this.selectDefaultPath = this.newArray.filter(elem => elem.value === this.defaultPath);
                    }
                    if (!this.selectedPluginConfigData.apiConfigure) {
                        this.showRequest = false;
                        this.showResponse = false;
                        this.errors = [];
                    }
                } else {
                    this.showToastApiNotFound();
                }
            }
        },

        // eslint-disable-next-line consistent-return
        checkError(value) {
            for (let i = 0; i < value.length; i++) {
                if (value && !value[i].action) {
                    return true;
                }
            }
        },
        action($event) {
            if ($event === "primary") {
                // eslint-disable-next-line no-unused-expressions,no-sequences
                (this.requestToLoad = []), (this.responseToLoad = []);
                const responseErr = this.checkError(this.errors);
                let noResponse; let
                    noRequest;
                this.changeRequestResponse = false;
                if (!this.selectApiMethod.length) {
                    this.selectedErrorMethod = true;
                    return;
                }
                this.selectedErrorMethod = false;
                if (this.defaultPath && !responseErr) {
                    const request1 = this.getRequestMappingData();
                    const response1 = this.responseObjectTosend(this.arrayRulesList, this.errors);
                    const response2 = { code: 200, response: this.getResponseMappingData(), action: this.defaultPath };
                    if (this.customHeaderListRequest.length) {
                        request1.__customHeaders = {};
                        this.customHeaderListRequest.forEach(el => {
                            if (el.parameterLabel) {
                                request1.__customHeaders[el.parameterLabel] = el.paramValue;
                            }
                        });
                        if (!Object.keys(request1.__customHeaders).length) {
                            delete request1.__customHeaders;
                        }
                    } else {
                        delete request1.__customHeaders;
                    }
                    if (this.customHeaderListResponse.length) {
                        response2.response.__customHeaders = {};
                        this.customHeaderListResponse.forEach(el => {
                            if (el.parameterLabel) {
                                response2.response.__customHeaders[el.parameterLabel] = el.paramValue;
                            }
                        });
                        if (!Object.keys(response2.response.__customHeaders).length) {
                            delete response2.response.__customHeaders;
                        }
                    } else {
                        delete response2.response.__customHeaders;
                    }
                    this.dmMappedValueObject = {
                        api: this.selectApiMod.length ? this.selectApiMod[0].value : "",
                        apiId: this.selectApiMod.length && this.selectApiMod[0].id ? this.selectApiMod[0].id : null,
                        method: this.selectApiMethod.length ? this.selectApiMethod[0].value : "",
                        requests: request1,
                        responses: response1.concat(response2),
                        __version: 2,
                        defaultPath: this.defaultPath
                    };
                    noRequest = this.checkIfHasResponseRequest(request1);
                    noResponse = this.checkIfHasResponseRequest(response2);

                    if (noRequest || noResponse) {
                        // eslint-disable-next-line no-nested-ternary
                        const warningMessage = noRequest && noResponse
                            ? this.$t(
                                "diagrams.components.configApi.warningRequestResponse"
                            )
                            : noRequest
                                ? this.$t("diagrams.components.configApi.warningRequest")
                                : this.$t("diagrams.components.configApi.warningResponse");
                        this.$toast.showNotify({
                            type: "warning",
                            message: warningMessage
                        });
                    }
                    this.$store.commit("diagrams/setConfigData", {
                        uuid: this.uuid,
                        value: this.dmMappedValueObject,
                        property: "apiConfigure"
                    });
                    this.errorDefaultPath = false;
                    this.hide();
                } else if (responseErr) {
                    this.$toast.showNotify({
                        type: "error",
                        message: this.$t("diagrams.components.configApi.warningError")
                    });
                } else if (!this.defaultPath) {
                    this.errorDefaultPath = true;
                }
            } else if ($event === "close") {
                if (this.dirty) {
                    this.showDialog = true;
                } else {
                    this.hide();
                }
            }
            this.requestValue = false;
            this.responseValue = false;
        },

        checkIfHasResponseRequest(data) {
            let hasWarning; let
                childHasValue;
            if (data && data.constructor === Object) {
                // eslint-disable-next-line no-restricted-syntax
                for (const i in data) {
                    if (data[i] && data[i].constructor === Object) {
                        // eslint-disable-next-line no-restricted-syntax
                        for (const k in data[i]) {
                            if (data[i][k]) {
                                childHasValue = true;
                                break;
                            } else {
                                hasWarning = true;
                            }
                        }
                    } else if (data[i]) {
                        hasWarning = false;
                        break;
                    } else {
                        hasWarning = true;
                    }
                }
            }
            if (data.__customHeaders) {
                Object.keys(data.__customHeaders).forEach(key => {
                    if (!data.__customHeaders[key]) {
                        childHasValue = false;
                        hasWarning = true;
                    }
                });
            }
            return childHasValue ? !childHasValue : hasWarning;
        },

        hide() {
            this.customHeaderListRequest = [];
            this.customHeaderListResponse = [];
            this.modalOpened = false;
            this.saveEnable = false;
            this.dirty = false;
            this.tabsConfiguration = "request";
            this.$store.commit("diagrams/setIsFromResponse", false);
        },

        changeResponse(apiIdNow, method, data) {
            if (apiIdNow && method) {
                this.getResponseCallApi({ apiId: apiIdNow, method }).then((beData) => {
                    this.responseObject = { data: beData.data.object, tab: "response" };
                    this.responseObjectSections = this.responseObject.data.responses["200"].response[0].fields
                        ? this.responseObject.data.responses["200"].response[0].fields.map(item => item.name) : [];
                    this.showResponse = true;
                });
                this.getErrorsCallApi({ apiId: apiIdNow, method }).then(dataErrors => {
                    this.errors = [];
                    this.errors = dataErrors ? Object.entries(dataErrors) : [];
                    // eslint-disable-next-line max-len
                    if ((data && data.length > 0) || (this.selectedPluginConfigData && this.selectedPluginConfigData.apiConfigure && this.selectedPluginConfigData.apiConfigure.responses)) {
                        const response = this.selectedPluginConfigData.apiConfigure.responses || data;
                        this.loadCardsData(response);
                    }
                });
            }
        },
        changeRequest(apiIdNow, method) {
            if (apiIdNow && method) {
                this.getRequestCallApi({ apiId: apiIdNow, method }).then((data) => {
                    if (data && data.data) {
                        this.requestObject = { data: data.data.object, tab: "request" };
                        this.requestObjectSections = this.requestObject.data.requests[0].fields
                            ? this.requestObject.data.requests[0].fields.map(item => item.name) : [];
                        this.showRequest = true;
                    }
                });
            }
        },
        addRules() {
            this.openModalRule = true;
        },

        dataNotChange() {
            const currentApi = this.findApiConfigured();
            if (currentApi && this.selectedPluginConfigData.apiConfigure
                && this.selectedPluginConfigData.apiConfigure.request
            ) {
                this.changeRequest(
                    currentApi.id,
                    this.selectedPluginConfigData.apiConfigure.method,
                    this.selectedPluginConfigData.apiConfigure.request
                );
            }
            if (
                currentApi && this.selectedPluginConfigData.apiConfigure
                && this.selectedPluginConfigData.apiConfigure.responses
            ) {
                this.changeResponse(
                    currentApi.id,
                    this.selectedPluginConfigData.apiConfigure.method,
                    this.selectedPluginConfigData.apiConfigure.responses
                );
            }
            this.changeRequestResponse = false;
            // eslint-disable-next-line max-len
            this.defaultPath = this.selectedPluginConfigData.apiConfigure && this.selectedPluginConfigData.apiConfigure.defaultPath ? this.selectedPluginConfigData.apiConfigure.defaultPath : "";
            if (this.defaultPath) {
                this.selectDefaultPath = this.newArray.filter(elem => elem.value === this.defaultPath);
            } else {
                this.resetDefaultPathOption = true;
                setTimeout(() => {
                    this.resetDefaultPathOption = false;
                }, 0);
            }
            setTimeout(() => { this.modalOpened = true; }, 500);
        },

        openModal() {
            this.createActions();
            this.setDataForLoad();
            if (this.changeRequestResponse) {
                this.dataNotChange();
            } else {
                this.modalOpened = true;
                this.apiOptions = this.setAllAppi.map(param => ({
                    label: param.platformName || param.name,
                    value: param.platformName || param.name,
                    id: param.id
                }));
                this.disableMethod = !this.selectedPluginConfigData.apiConfigure;
                if (this.selectedPluginConfigData.apiConfigure) {
                    const currentApi = this.findApiConfigured();
                    if (currentApi) {
                        this.selectApiMod = [{
                            label: currentApi.platformName || currentApi.name,
                            value: currentApi.platformName || currentApi.name,
                            id: currentApi.id
                        }];
                        this.apiMethodsOptions = this.parseMethod(currentApi.webServiceMethods);
                    } else {
                        this.selectApiMod = [];
                        this.apiMethodsOptions = [];
                    }
                    this.selectApiMethod = this.apiMethodsOptions.filter(elem => elem.value === this.selectedPluginConfigData.apiConfigure.method);
                    this.showRequest = true;
                    this.showResponse = true;
                } else {
                    this.resetMethodsMod = true;
                    this.resetApiMod = true;
                    this.resetDefaultPathOption = true;
                    this.selectApiMethod = [];
                    this.selectApiMod = [];
                    this.selectDefaultPath = [];
                    setTimeout(() => {
                        this.resetMethodsMod = false;
                        this.resetApiMod = false;
                        this.resetDefaultPathOption = false;
                    }, 0);
                }
                this.loadDataForApi();
                if (this.defaultPath && this.arrayOption && !this.arrayOption.length) {
                    this.selectDefaultPath = this.newArray.filter(elem => elem.value === this.defaultPath);
                }
            }
        },
        showToastApiNotFound() {
            if (!this.toastApiNotFound) {
                this.toastApiNotFound = this.$toast.showNotify({
                    type: "error",
                    message: this.$t("diagrams.components.configApi.apiNotFound", {
                        name: this.selectedPluginConfigData.apiConfigure.api
                    }),
                    timeout: 3000
                });
            }
        },
        setDataForLoad() {
            if (this.selectedPluginConfigData.apiConfigure
                && (this.selectedPluginConfigData.apiConfigure.requests || this.selectedPluginConfigData.apiConfigure.responses)) {
                this.requestMappingData = this.selectedPluginConfigData.apiConfigure.requests;
                const respNow = this.selectedPluginConfigData.apiConfigure.responses.find(resp => resp.code === 200);
                this.responseMappingData = respNow ? respNow.response : null;
            }
        },
        getRequestMappingData() {
            return { ...this.requestMappingData, ...this.unsavedRequestMappingData };
        },
        getResponseMappingData() {
            return { ...this.responseMappingData, ...this.unsavedResponseMappingData };
        },
        discardUnsavedMappings() {
            this.unsavedRequestMappingData = {};
            this.unsavedResponseMappingData = {};
        },
        discardSavedMappings() {
            this.requestMappingData = null;
            this.responseMappingData = null;
        }
    }
};
